export default __webpack_public_path__ + "static/media/maritime.6d8f2a19.png";